function registerVideoControllerHandlers(session, videoController) {
  videoController.registerPlayHandler(() => {
    if (session.getCurrentSessionState() === "Paused") {
      session.play();
    }
  });
  videoController.registerPauseHandler(() => {
    session.pause();
  });
  videoController.registerSetVolumeHandler((volume) => {
    session.setVolume(volume);
  });
  videoController.registerSetMuteHandler((mute) => {
    session.setMute(mute);
  });
  videoController.registerEnableSubtitlesHandler((trackId) => {
    session.enableSubtitles(trackId);
  });
  videoController.registerDisableSubtitlesHandler(() => {
    session.disableSubtitles();
  });
  videoController.registerSeekToHandler((seekTime) => {
    session.seek(seekTime);
  });
  return function unRegisterVideoControllerHandlers() {
  };
}
export {
  registerVideoControllerHandlers
};
//# sourceMappingURL=registerVideoControllerHandlers.js.map
